"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DebtinatorRuleEditor = _interopRequireDefault(require("../DebtinatorRuleEditor"));

var _RepeatRuleBook = _interopRequireDefault(require("./RepeatRuleBook.json"));

var _repeatRuleProcessors = _interopRequireDefault(require("./repeat-rule-processors"));

var RepeatRuleEditor = function RepeatRuleEditor(_ref) {
  var rules = _ref.rules,
      setRules = _ref.setRules;
  return /*#__PURE__*/_react.default.createElement(_DebtinatorRuleEditor.default, {
    ruleBook: _RepeatRuleBook.default,
    rules: rules,
    setRules: setRules,
    processors: _repeatRuleProcessors.default
  });
};

var _default = RepeatRuleEditor;
exports.default = _default;